import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import pageTransition from "../components/pageTransition";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import MetaHelmet from "../components/metaHelmet";

const AGB: React.FC = () => {
    const { t } = useTranslation();

    // Load settings
    const [language] = useState(localStorage.getItem('i18nextLng') || 'en');

    const location = useLocation();
    const internalOrigin = location.state?.fromInternal || false;
    const { trackPageView } = useMatomo();

    const navigate = useNavigate();

    useEffect(() => {
        trackPageView({
            href: window.location.href, // URL der aktuellen Seite
        });
    }, [location]);

    return (
        <ion-page class="sg-body generic">
            <div className="page-container">
                <MetaHelmet
                    title={t('AGB')}
                />
                <img className="post-image" src={'/images/sG_fallback_small.jpeg'} />
                <div className="header-container ion-padding news">
                    {internalOrigin && <button className="arrow-back" style={{ backgroundImage: `url("/icons/back_arrow_white.svg")` }} onClick={() => navigate(-1)}></button>}
                    <strong className="start-title">
                        {t('AGB')}
                    </strong>
                </div>
                <div className="generic-page agb">
                    <main>
                        <header>
                            <strong>Allgemeine Geschäftsbedingungen (AGB) für die Nutzung der Gastroplattform smartGastro</strong>
                        </header>


                        <section>
                            <strong>1. Geltungsbereich</strong>
                            <p>1.1 Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung der Internetplattform smartGastro (im Folgenden „Plattform“) durch Besucher und gastronomische Betriebe (im Folgenden „Betriebe“ oder „Partner“).</p>
                            <p>1.2 Abweichende Bedingungen werden nicht anerkannt, es sei denn, der Betreiber stimmt ihrer Geltung ausdrücklich schriftlich zu.</p>
                        </section>


                        <section>
                            <strong>2. Betreiber der Plattform</strong>
                            <p>
                            smartBite OG<br />
                            Mariagrünerstraße 33<br />
                            8043 Graz, Österreich<br /><br />
                            Tel:+436764647177<br />
                            E-Mail:info@smartgastro.at<br /><br />
                            FN: 646017a<br />
                            FB-Gericht: Graz<br />
                            </p>
                        </section>


                        <section>
                            <strong>3. Leistungsbeschreibung</strong>
                            <p>3.1 Die Plattform dient der Darstellung und Auffindbarkeit gastronomischer Betriebe.</p>
                            <p>3.2 Für Besucher ist die Nutzung kostenfrei und ohne Registrierung möglich.</p>
                            <p>3.3 Alle gastronomischen Betriebe werden zunächst kostenfrei gelistet. Optional können Betriebe kostenpflichtige Zusatzleistungen („Partner-Features“) buchen, um ihre Sichtbarkeit und Präsentation zu erweitern.</p>
                            <p>3.4 Der Betreiber behält sich vor, Inhalte und Funktionen der Plattform jederzeit zu ändern oder einzuschränken.</p>
                        </section>


                        <section>
                            <strong>4. Nutzung durch Besucher</strong>
                            <p>4.1 Die Nutzung der Inhalte der Plattform ist ausschließlich zu privaten, nicht-kommerziellen Zwecken gestattet.</p>
                            <p>4.2 Eine Vervielfältigung, Weitergabe oder sonstige Nutzung der Inhalte, insbesondere von Texten, Bildern, Logos oder Datenbankinhalten, bedarf der vorherigen schriftlichen Zustimmung des Betreibers.</p>
                            <p>4.3 Handlungen, die geeignet sind, die Funktionsfähigkeit der Plattform zu beeinträchtigen oder unbefugten Zugriff auf Systeme oder Daten zu ermöglichen (z. B. Hacking, automatisiertes Auslesen/Scraping), sind untersagt.</p>
                            <p>4.4 Der Betreiber übernimmt keine Gewähr für die Richtigkeit, Vollständigkeit oder Aktualität der Inhalte. Die Nutzung der Informationen erfolgt auf eigene Verantwortung des Besuchers.</p>
                        </section>


                        <section>
                            <strong>5. Nutzung durch Betriebe</strong>
                            <strong>5.1 Kostenfreier Eintrag</strong>
                            <p>Alle gastronomischen Betriebe werden kostenfrei in der Plattform gelistet. Der Betreiber behält sich vor, Angaben zu prüfen, zu kürzen oder anzupassen, um eine einheitliche Darstellung zu gewährleisten.</p>


                            <strong>5.2 Partner-Features</strong>
                            <p>Betriebe können kostenpflichtige Zusatzleistungen („Partner-Features“) buchen, die eine erweiterte Darstellung oder bessere Sichtbarkeit ermöglichen.
                                Die jeweils gültigen Preise und Leistungsbeschreibungen werden dem Betrieb vor Vertragsabschluss in Textform zur Verfügung gestellt.
                                Die Preisliste ist nicht öffentlich einsehbar.</p>

                            <p>Weitere Details unter: <Link state={{ fromInternal: true }} to={"/partner"}>https://smartgastro.at/partner</Link> </p>


                            <strong>5.3 Vertragsabschluss und Laufzeit</strong>
                            <p>Ein Vertrag über Partner-Features kommt durch Annahme des schriftlichen Angebots durch den Betrieb zustande. Mit dem Angebot erhält der Betrieb die gültige Preisliste sowie die Leistungsbeschreibung der gebuchten Features. Der Vertrag wird auf eine bestimmte Laufzeit fixiert und wird danach nicht automatisch verlängert.</p>


                            <strong>5.4 Kennzeichnung von Partner-Inhalten</strong>
                            <p>Partner-Features werden entsprechend den gesetzlichen Bestimmungen (insbesondere der EU-Omnibus-Richtlinie) als bezahlte Platzierung gekennzeichnet.</p>
                            <p>Partner-Inhalte und bezahlte Platzierungen sind auf der Plattform mit folgendem Symbol gekennzeichnet:</p>
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <img src="/icons/partner_white.svg" style={{ maxWidth: "35px" }} />
                            <div style={{ backgroundColor: "white", borderRadius: "50%", width: "45px", height: "45px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <img src="/icons/partner_green.svg" alt="Partner Icon" style={{ maxWidth: "35px" }} />
                            </div>
                            </div>
                            <span className="partner"></span>
                            <p>Dieses Symbol weist darauf hin, dass die entsprechende Darstellung auf einer kostenpflichtigen Partner-Option für Betriebe basiert. Partner-Inhalte können in Listen eine bevorzugte Platzierung oder eine erweiterte Darstellung erhalten.</p>


                            <strong>5.5 Haftung und Verantwortung</strong>
                            <p>Der Betreiber übernimmt keine Haftung für die Richtigkeit der vom Betrieb bereitgestellten Inhalte. Für Schäden, die durch unzutreffende Angaben entstehen, haftet ausschließlich der Betrieb.</p>


                            <strong>5.6 Kündigung und Löschung</strong>
                            <p>Der Betreiber ist berechtigt, Betriebe bei Verstößen gegen diese AGB ohne Vorankündigung aus der Plattform zu entfernen. Partner-Verträge können unter Einhaltung der vereinbarten Fristen gekündigt werden. (14 Tage)</p>
                        </section>


                        <section>
                            <strong>6. Haftung des Betreibers</strong>
                            <p>
                                Die Plattform smartGastro stellt die Inhalte der Betriebe lediglich dar und übernimmt keine Gewähr für deren Richtigkeit, Vollständigkeit oder Aktualität.
                                Eine Haftung der Plattform für Schäden, die durch die Nutzung der Plattform entstehen, ist – soweit gesetzlich zulässig – ausgeschlossen, insbesondere für leichte Fahrlässigkeit.
                                Dies gilt nicht für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit oder aus vorsätzlichem oder grob fahrlässigem Verhalten.</p>
                        </section>


                        <section>
                            <strong>7. Geistiges Eigentum</strong>
                            <p>Alle auf der Plattform veröffentlichten Inhalte, Designs, Logos und Datenbanken sind urheberrechtlich geschützt. Jede nicht ausdrücklich genehmigte Nutzung ist untersagt.</p>
                        </section>


                        <section>
                            <strong>8. Datenschutz</strong>
                            <p>Die Verarbeitung personenbezogener Daten erfolgt gemäß der Datenschutzerklärung, die unter <Link state={{ fromInternal: true }} to={"/datenschutz"}>https://smartgastro.at/datenschutz</Link> abrufbar ist.</p>
                        </section>


                        <section>
                            <strong>9. Änderungen der AGB</strong>
                            <p>Die Plattform behält sich das Recht vor, die AGB jederzeit zu ändern. Änderungen werden den Partnerbetrieben mindestens [z. B. 14 Tage] vor Inkrafttreten in Textform (z. B. per E-Mail) mitgeteilt. Widerspricht ein Partnerbetrieb den Änderungen nicht innerhalb von [z. B. 14 Tagen], gelten die Änderungen als angenommen.
                                Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
                        </section>


                        <section>
                            <strong>10. Anwendbares Recht und Gerichtsstand</strong>
                            <p>10.1 Es gilt ausschließlich österreichisches Recht unter Ausschluss der Kollisionsnormen und des UN-Kaufrechts.</p>
                            <p>10.2 Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Betreibers.</p>
                        </section>


                        <section>
                            <strong>11. Salvatorische Klausel</strong>
                            <p>Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
                        </section>


                        <footer>
                            <p><u>Letzte Änderung: 1.11.2025</u></p>
                        </footer>
                    </main>
                </div>
            </div>
        </ion-page>
    );
}

export default pageTransition(AGB);
